// extracted by mini-css-extract-plugin
export default {"body":"layout_body__g7R4Q","conteiner":"layout_conteiner__zItyl"};